/* 섬네일 줄 좌우 화살표 — 2026-09-14 의장 「화살표도 넣어」.
   사진이 많은 상품은 섬네일 줄이 넘친다. 넘칠 때만 화살표를 낸다.
   2026-10-20 의장 지시로 **모바일에서도 낸다**(종전에는 1000px 미만에서 숨겼다),
   그리고 **끝에서 반대쪽 끝으로 돈다**(소서 개선점 4번. 종전에는 끝에서 화살표를 감췄다).
   테마의 flickity-controls 가 data-action 을 가로채므로 우리 이름(data-ue-thumbnav)만 쓴다. */
(function () {
  'use strict';

  /* 2026-10-20: 폭 경계를 쓰지 않는다 — 모바일에서도 화살표를 낸다 (의장) */

  function 줄찾기(단추) {
    var 판 = 단추.closest('.product__media-nav');
    return 판 ? 판.querySelector('.product__thumbnail-list') : null;
  }

  function 한칸(줄) {
    var 첫 = 줄.querySelector('.product__thumbnail-item');
    if (!첫) return 200;
    var 폭 = 첫.getBoundingClientRect().width;
    // 칸이 짜부라진 상태(겹침)면 안쪽 사진 너비를 쓴다
    var 속 = 첫.querySelector('.product__thumbnail');
    if (속) 폭 = Math.max(폭, 속.getBoundingClientRect().width);
    return Math.max(폭, 24);
  }

  function 갱신(판) {
    var 줄 = 판.querySelector('.product__thumbnail-list');
    var 앞 = 판.querySelector('[data-ue-thumbnav="prev"]');
    var 뒤 = 판.querySelector('[data-ue-thumbnav="next"]');
    if (!줄 || !앞 || !뒤) return;

    var 넘침 = 줄.scrollWidth - 줄.clientWidth;

    /* ⛔ 2026-10-20 의장 「모바일에서도 화살표 나오게 해」
       종전에는 1000px 미만에서 화살표를 통째로 숨겼다(2026-09-14).
       이제 **폭과 상관없이** 넘치기만 하면 내보낸다. */
    if (넘침 <= 2) {
      앞.hidden = true;
      뒤.hidden = true;
      return;
    }
    /* ⛔ 2026-10-20 — 끝에 닿으면 그쪽 화살표를 **감추던 것을 그만둔다**
       (소서 개선점 4번: 「마지막 이미지에서 다음 화살표를 누르면 다시 첫 번째로」).
       이제 끝에서도 눌러서 **반대쪽 끝으로 돌아간다** — 감추면 누를 수가 없다. */
    앞.hidden = false;
    뒤.hidden = false;
  }

  function 모두갱신() {
    document.querySelectorAll('.product__media-nav').forEach(갱신);
  }

  document.addEventListener('click', function (e) {
    var 단추 = e.target.closest ? e.target.closest('[data-ue-thumbnav]') : null;
    if (!단추) return;
    e.preventDefault();
    e.stopPropagation();

    var 줄 = 줄찾기(단추);
    if (!줄) return;

    // 한 번에 보이는 만큼 밀되, 칸 하나는 겹쳐 보여 준다
    var 칸 = 한칸(줄);
    var 걸음 = Math.max(칸, 줄.clientWidth - 칸);
    var 앞으로 = 단추.getAttribute('data-ue-thumbnav') === 'prev';
    var 넘침 = 줄.scrollWidth - 줄.clientWidth;

    /* ── 순환 (2026-10-20 소서 개선점 4번) ─────────────────────
       끝에 닿아 있으면 **반대쪽 끝으로 돌아간다.**
       ⚠ 「끝에 닿았나」는 2px 안쪽으로 본다 — 부분픽셀 때문에 정확히 0/최대가 안 된다.
       ⚠ 돌아갈 때는 부드럽게 밀지 않고 **한 번에 옮긴다** — 긴 줄을 스르륵 되감으면
          손님 눈에는 고장처럼 보인다. */
    var 끝인가 = !앞으로 && 줄.scrollLeft >= 넘침 - 2;
    var 처음인가 = 앞으로 && 줄.scrollLeft <= 2;

    if (끝인가 || 처음인가) {
      var 옛동작 = 줄.style.scrollBehavior;
      줄.style.scrollBehavior = 'auto';
      줄.scrollLeft = 끝인가 ? 0 : 넘침;
      줄.style.scrollBehavior = 옛동작;
      return;
    }

    줄.scrollLeft += (앞으로 ? -걸음 : 걸음);
  }, true);

  document.addEventListener('scroll', function (e) {
    var 줄 = e.target;
    if (줄 && 줄.classList && 줄.classList.contains('product__thumbnail-list')) {
      var 판 = 줄.closest('.product__media-nav');
      if (판) 갱신(판);
    }
  }, true);

  window.addEventListener('resize', 모두갱신);
  document.addEventListener('shopify:section:load', 모두갱신);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', 모두갱신);
  } else {
    모두갱신();
  }
  // 사진이 늦게 뜨면 넘침 폭이 달라진다 — 한 번 더 본다
  window.addEventListener('load', 모두갱신);
})();
